import vndly_logo from "../media/timeline/vndly_logo.png"
import uc_logo from "../media/timeline/uc.png"
import aviso_logo from "../media/timeline/aviso_old.png"
import kmit_logo from "../media/timeline/kmit.jpg"
import bioTrillionLogo from "../media/timeline/biotrillion.png"
import acvLogo from "../media/timeline/acv_logo_white.png"

export const bio = `

I am a Deep Learning Engineer with background in Software,
Master's in Artificial Intelligence.

I am obsessed with Neural Networks 🧠, Evolution 🧬 and Astrophysics 🪐 

`

export const timeline = {
  acv: {
    role: "Machine Learning Engineer ||| - R&D",
    org: "ACV Auctions",
    year: "2021 Nov",
    img: acvLogo,
    description:
      "R&D of various Deep Learning based solutions for car inspections.",
  },
  bio_trillion: {
    role: "Computer Vision Engineer",
    org: "BioTrillion",
    year: "2021 May",
    img: bioTrillionLogo,
    description: `R&D of pupillometry using Deep Learning techniques like Semantic Segmentation, Detection, etc.`,
  },
  vndly: {
    role: "Developer",
    org: "VNDLY",
    year: "2020 May",
    img: vndly_logo,
    description: `NLP Tasks - Semantic Text Similarity based on BERT, segments highlighter \\
Technologies: _PyTorch, TensorFlow, Django, React_`,
  },
  uc: {
    role: "Master’s in Artificial Intelligence",
    org: "University of Cincinnati",
    year: "2019 Aug",
    img: uc_logo,
    description: `Specializations: _Computer Vision, NLP, Reinforcement Learning and Complex Intelligent Systems_`,
  },
  aviso: {
    role: "Full-Stack Engineer",
    org: "Aviso AI",
    year: 2018,
    img: aviso_logo,
    description: `Reduced the ML cloud cost by **60%** \\
Technologies used: _Django, Kubernetes, AWS, Linux, Puppet, Vue.js_`,
  },
  kmit_dev: {
    role: "Part-Time Developer",
    org: "Keshav Memorial Institute of Technology",
    year: 2015,
    img: kmit_logo,
    description: `Developed apps for the college’s operations like Student Feedback and Gate-Pass System`,
  },
  kmit: {
    role: "Bachelor's in Computer Science and Engineering",
    org: "Keshav Memorial Institute of Technology",
    year: 2014,
    img: kmit_logo,
    description: `My first adventures with programming`,
  },
}

export const codingActivity = `

I absolutely ❤ coding! Each box below represents the amount of coding on that day of the year. Darker box = lot of code

From GitHub [@Akhilez](https://github.com/Akhilez)

`

export const revolutionUc = `
RevolutionUC is a hackathon conducted by 
ACM at University of Cincinnati with roughly 400 participants.
`

export const neuralHack = `NeuralHack is an India-wide hackathon with approximately 13,000 participants conducted by Virtusa`

export const mlGalleryDescription = `

A gallery of Deep Learning projects.\n
Every project here is runnable, visualized and explained clearly.

`
